import React, { FC, ReactNode } from 'react';
import styled from 'styled-components';
import { BodyShort01 } from 'components/styles';
import { CellWrapper, NameCell } from './component';

interface Props {
  text: ReactNode;
  icon?: ReactNode;
  onWrapperClick?: () => void;
}
const NameWrapper = styled.span`
  ${BodyShort01};
  color: var(--gray-80);
  display: flex;
  align-items: center;
  > svg {
    flex-shrink: 0;
    margin-right: var(--spacing-03);
    color: var(--gray-70);
  }
`;

export const DemandNameCell: FC<Props> = ({ onWrapperClick, text, icon }) => {
  return (
    <CellWrapper onClick={onWrapperClick}>
      <NameCell
        logo={null}
        primaryText={
          <>
            <NameWrapper>
              {icon} {text}
            </NameWrapper>
          </>
        }
      />
    </CellWrapper>
  );
};
